import { useCallback, useRef } from 'react';
import { v4 as uuid } from 'uuid';
import { NATIVE_POST_MESSAGE_TYPE } from '../../constants';
import useNativeMessageEventListener from '../useNativeMessageEventListener';
import { useNativePostMessage } from '../useNativePostMessage';
import useConfirmExit from './hooks/useConfirmExit';

interface ConfirmExitParams {
  callback: () => void;
  path: string;
}

interface RefPathInPending {
  [key: string]: () => void;
}

const usePrompt = (): void => {
  const refPathInPending = useRef<RefPathInPending>({});
  const nativePostMessage = useNativePostMessage();
  useNativeMessageEventListener({ refPathInPending });

  const confirmExit = useCallback(
    ({ callback, path }: ConfirmExitParams) => {
      const cid = uuid();
      refPathInPending.current = {
        ...refPathInPending.current,
        [cid]: callback
      };
      nativePostMessage({
        type: NATIVE_POST_MESSAGE_TYPE.ROUTE,
        path,
        cid
      });
    },
    [nativePostMessage]
  );

  useConfirmExit(confirmExit);
};

export default usePrompt;
